import type { Topic } from 'api/contentful/contentTypes.cloverdotcom';
import type { ReferencedEntry } from 'contentful';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { getField } from 'utils/EntryUtil';
import { Blurb } from '../Contentful/Blurb';
import { ModalHeader } from '../Modal/Header/ModalHeader';
import { onRequestClose } from '../NestedRoute/NestedModals';

interface ITextModalProps extends RouteComponentProps {
  entry?: ReferencedEntry<Topic>;
  children?: never;
  modalBaseUrl?: string;
}

const TextModal: React.FC<ITextModalProps> = ({ entry, history, match, modalBaseUrl }) => {
  return (
    <>
      <ModalHeader
        heading={getField(entry, 'title')}
        onCloseButtonClick={() => onRequestClose(history, match, modalBaseUrl)}
      />
      <Blurb entry={entry} field="blurb" />
    </>
  );
};

const WithRouter = withRouter(TextModal);

export { WithRouter as TextModal };
